
import { parse, isValid, isAfter, isBefore } from 'date-fns'
import { enUS } from 'date-fns/locale'

/**
 *
 * @param month a month starting with 1 for january and going to 12 for december
 * @param day
 * @param year
 * @returns if the date is a valid date
 */
export function isValidDate (month: string | number | undefined, day: string | number | undefined, year: string | number | undefined) {
  const parsedDate = parse(`${month}/${day}/${year}`, 'P', new Date(), { locale: enUS })
  const isValidDate = isValid(parsedDate)
  // max date is 12/31/2100
  const maxDate = parse(`1/1/2100`, 'P', new Date(), { locale: enUS })
  const isLessThanMaxDate = isBefore(parsedDate, maxDate)
  return (isValidDate && isLessThanMaxDate)
}

/**
 *
 * @param month a month starting with 1 for january and going to 12 for december
 * @param day
 * @param year
 * @returns the parsed date object
 */
export function parseDate (month: string | number | undefined, day: string | number | undefined, year: string | number | undefined) {
  const parsedDate = parse(`${month}/${day}/${year}`, 'P', new Date(), { locale: enUS })
  return (parsedDate)
}

export function toDateString (date: Date) {
  return (date.toLocaleDateString())
}
// start and end dates cannot come before today
// end date must be > start date

export const isEndDateValid = (startDate: Date, endDate: Date): boolean => {
  const dateGreaterThanStartDate = isAfter(endDate, startDate)
  const dateGreaterThanToday = isAfter(endDate, new Date())
  return isValidDate(endDate.getMonth() + 1, endDate.getDate(), endDate.getFullYear()) && dateGreaterThanStartDate && dateGreaterThanToday
}

export const isStartDateValid = (startDate: Date): boolean => {
  const today = new Date(new Date().setHours(0, 0, 0, 0))
  const dateGreaterThanToday = startDate >= today
  return isValidDate(startDate.getMonth() + 1, startDate.getDate(), startDate.getFullYear()) && dateGreaterThanToday
}

export const isValidDateObject = (dateObj?: { day?: string | undefined | number, month?: string | undefined | number, year?: string | undefined | number }) => {
  return Boolean(dateObj?.day && dateObj?.month && dateObj?.year)
}
